<mat-form-field>
  <input
    matInput
    placeholder="Zoek Gebruiker"
    aria-label="user"
    [matAutocomplete]="auto"
    [formControl]="searchCtrl"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selectedMember()"
      [displayWith]="getMemberName"
      >
      @for (member of filteredMembers | async; track member) {
        <mat-option [value]="member">
          @if (member.image) {
            <img
              class="example-option-img"
              [src]="member.image.imageUrl"
              height="25"
              alt="profielfoto van {{member.firstName}}"
              />
          }
          @if (!member.image) {
            <img
              class="example-option-img"
              src="/assets/images/no_photo.png"
              height="25"
              alt="profielfoto van {{member.firstName}}"
              />
          }
          {{ member.firstName }} {{ member.infix }} {{ member.lastName }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
